import React from 'react';
interface IconProps {
  width?: number;
  height?: number;
}

const HomeValueIconTussenwoning = (props: IconProps) => {
  return (
    <svg width={56} height={53} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M25.666 52.222V32.777H17.89v19.445"
        stroke="currentColor"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M59.957 52.22H-3.89" stroke="currentColor" strokeWidth={1.5} strokeLinecap="round" />
      <path
        d="M-3.111 1.666c.803 0 10.705 8.296 15.555 12.445L28 1.665 43.555 14.11 59.111 1.666"
        stroke="currentColor"
        strokeWidth={1.5}
        strokeLinejoin="round"
      />
      <path
        d="M12.444 16.443v35.778h31.111V16.443"
        stroke="currentColor"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        stroke="currentColor"
        strokeWidth={1.5}
        strokeLinejoin="round"
        d="M17.889 19.555h7.778v7.778h-7.778zM31.111 32.777h7.778v7.778h-7.778zM31.111 19.555h7.778v7.778h-7.778z"
      />
    </svg>
  );
};

export default HomeValueIconTussenwoning;
